import styled from 'styled-components'
import theme from '../../theme'

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.background.color};
  height: 100vh;
  padding: 2rem;
  width: 100%;
  @media (max-width: 768px) {
   padding:1rem;
  }
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 100%;
  width: 70%;
  @media (max-width: 768px) {
    width:100%;
  }
`

export const Title = styled.h1`
  font-family: 'Inter';
  align-self: center;
  padding: 2rem 0;
  @media (max-width: 768px) {
   font-size:1.5rem;
  }
`

export const Paragraph = styled.p`
  font-size: 20px;
`